const locale = {
  placeholder: 'Vybrat čas',
};

export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/cs_CZ.tsx